import React, { useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DoneIcon from "@mui/icons-material/Done";
import "./FileUploader.css";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Box, ListItemIcon, Menu, Popover } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import toast, { Toaster } from "react-hot-toast";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import ArchiveIcon from "@mui/icons-material/Archive";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import logo from "../../image/ayekart logo.png";
import { useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useDispatch } from "react-redux";
import authService from "../../services/auth.service";
import Logout from "@mui/icons-material/Logout";
import { removeToken } from "../../redux/tokenSlice";
import { NavBar } from "../Navbar/NavBar";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Loader from "../Loader";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Existing client",
  "New client",
  "Repeat order",
  "Fresh funding",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const FileUploader = () => {
  const [file, setFile] = useState(null);
  const [fileFlag, setFileFlag] = useState(false);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("");

  // -------------------New states--------------
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const open1 = Boolean(anchorEl1);
  const dispatch = useDispatch();
  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const id = open1 ? "simple-popover" : undefined;
  const history = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const logout = () => {
    authService.logout();
    dispatch(removeToken);
    history("/login");
  };

  const theme = useTheme();
  const [tagName, setTagName] = React.useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setTagName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  // -------------------------------------------

  const handleFileDrop = (event) => {
    event.preventDefault();
    const token = localStorage.getItem("token");
    const file = event.dataTransfer.files[0];
    if (tagName[0] === undefined) {
      return toast.error("Please select Tag");
    }
    setFileFlag(true);
    setProgress(0);
    setFile(file);
    setStatus("Uploading...");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tag", tagName[0]);

    axios
      .post("/workflow/api/bulk_orders", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          setProgress(progress);
        },
      })
      .then((response) => {
        if (response?.data?.status === true) {
          setStatus("Uploaded");
          toast.success(response?.data?.message);
          setFileFlag(false);
        } else {
          setStatus("Failed");
          toast.error(response?.data?.message);
          setTimeout(() => {
            setFileFlag(false);
          }, 1000);
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleFileUpload = (event) => {
    const token = localStorage.getItem("token");
    const file = event.target.files[0];
    if (tagName[0] === undefined) {
      toast.error("Please select Tag");
      setTimeout(() => {
        return window.location.reload();
      }, 1000);
    } else {
      setFileFlag(true);
      setProgress(0);
      setFile(file);
      setStatus("Uploading...");
      const formData = new FormData();
      formData.append("file", file);
      formData.append("tag", tagName[0]);
      axios
        .post("/workflow/api/bulk_orders", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            setProgress(progress);
          },
        })
        .then((response) => {
          if (response?.data?.status === true) {
            setStatus("Uploaded");
            toast.success(response?.data?.message);
            setFileFlag(false);
            window.location.reload();
          } else {
            setStatus("Failed");
            toast.error(response?.data?.message);
            setTimeout(() => {
              setFileFlag(false);
              window.location.reload()
            }, 1000);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  return (
    <div className="container-fluid pt-3">
      <Loader loading={loading} />
      <NavBar />
      <div className="container-fluid mt-3 pt-4">
        <div className="row  ">
          <div className="col-12 pt-2 pb-2 d-flex justify-content-between">
            <span className="fs-5 fw-bold">
              <span
                className="text-secondary mr-2"
                onClick={() => history("/pre-order-list")}
                role="button"
              >
                /Pre- Order List
              </span>
              <span>/Upload file</span>
            </span>
          </div>
        </div>
      </div>
      <div className="container-fluid mb-3 ">
        <div className="row mx-0 d-flex justify-content-center">
          <div className="col-8">
            <div className="file-wrapper text-center">
              <div
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleFileDrop}
              >
                <label className="w-100 p-0 ">
                  <form action="#" className="pt-4 pb-2">
                    <CloudUploadIcon
                      role="button"
                      className="color-2C488F"
                      sx={{ fontSize: 60 }}
                    />
                    <input
                      className="file-input  "
                      id={"file-id"}
                      type="file"
                      accept=".csv"
                      onChange={handleFileUpload}
                      hidden
                    />
                    <p role="button">Drag & Drop or Choose file to Upload</p>
                  </form>
                </label>
                <div>
                  {/* <a
                    className="text-primary"
                    href={() => false}
                    onClick={() => history("/pre-order-list")}
                  >
                    Click here to view Batch List
                  </a> */}
                  <p>
                    Selected file:{" "}
                    {file?.name ? file?.name : "--No file selected--"}
                  </p>
                </div>
                {fileFlag && (
                  <div>
                    <div className="container-fluid">
                      <div className="row mx-0 d-flex justify-content-center">
                        <div className="col-12">
                          <div className="progress-area">
                            <li className="row mx-0">
                              <div className="col-1">
                                <InsertDriveFileIcon
                                  className="color-2C488F"
                                  sx={{ width: "auto", p: 0, fontSize: 40 }}
                                />
                              </div>
                              <div className="col-10">
                                <div className="content w-auto">
                                  <div className="details d-flex justify-content-between">
                                    <span className="name">{file.name}</span>
                                    <span
                                      className={
                                        status === "Failed"
                                          ? "text-danger"
                                          : "text-success"
                                      }
                                    >
                                      {status}
                                    </span>
                                  </div>
                                  <div className="progress-bar">
                                    <div
                                      className="progress"
                                      style={{ width: `${progress}%` }}
                                      id={"pros"}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-1">
                                <div className="percentage-div w-auto ms-1">
                                  <span className="percentage" id="Per">
                                    {progress}%
                                  </span>
                                </div>
                              </div>
                            </li>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row mx-0 mt-3 d-flex justify-content-center">
          <Select
            displayEmpty
            value={tagName}
            onChange={handleChange}
            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>Select Tag</em>;
              }

              return selected.join(", ");
            }}
            MenuProps={MenuProps}
            sx={{
              minWidth: 200,
              maxWidth: 250,
              bgcolor: "#2C488F",
              color: "#fff",
              borderRadius: 5,
              height: 50,
            }}
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem disabled value="">
              <em>Select Tag</em>
            </MenuItem>
            {names.map((name) => (
              <MenuItem
                key={name}
                value={name}
                style={getStyles(name, tagName, theme)}
              >
                {name}
              </MenuItem>
            ))}
          </Select>{" "}
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default FileUploader;
